(() => {
  if (window.DarPrirodeCart) return;

  const getRoot = () => window.Shopify?.routes?.root || '/';

  const updateCount = (cart) => {
    if (!cart) return;
    const count = Number(cart.item_count || 0);

    document
      .querySelectorAll('.cart-bubble__text-count, [data-cart-count], [data-cart-count-text]')
      .forEach((node) => {
        node.textContent = count > 99 ? '99+' : String(count);
      });

    document
      .querySelectorAll('.cart-bubble, .cart-count-bubble, [data-cart-count-bubble]')
      .forEach((node) => {
        node.classList.toggle('visually-hidden', count === 0);
      });
  };

  const refreshDrawer = async () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-drawer-section');

    const response = await fetch(url.toString(), {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return;

    const sections = await response.json();
    const html = sections['cart-drawer-section'];
    if (!html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextSection = parsed.querySelector('#shopify-section-cart-drawer-section');
    const currentSection = document.querySelector('#shopify-section-cart-drawer-section');

    if (nextSection && currentSection) {
      currentSection.replaceWith(nextSection);
    }

    if (typeof window.DarPrirodeInitCartDrawer === 'function') {
      window.DarPrirodeInitCartDrawer();
    }
  };

  const getCart = async () => {
    const response = await fetch(`${getRoot()}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Korpa se trenutno ne može osvježiti.');
    return response.json();
  };

  const addItems = async (items, source = 'dar-prirode') => {
    const cleanItems = items
      .map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity || 1))
      }))
      .filter((item) => item.id);

    if (!cleanItems.length) {
      throw new Error('Nije odabran nijedan dostupan proizvod.');
    }

    const response = await fetch(`${getRoot()}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: cleanItems })
    });

    if (!response.ok) {
      let message = 'Proizvodi nisu dodani u korpu.';
      try {
        const error = await response.json();
        message = error.description || error.message || message;
      } catch (_) {}
      throw new Error(message);
    }

    const cart = await getCart();
    updateCount(cart);
    await refreshDrawer();

    window.dispatchEvent(
      new CustomEvent('cart:update', {
        detail: { cart, source }
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: { cart, source }
      })
    );

    return cart;
  };

  const openDrawer = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
      return true;
    }

    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.showModal === 'function') {
      drawer.showModal();
      return true;
    }

    return false;
  };

  window.DarPrirodeCart = {
    addItems,
    getCart,
    openDrawer,
    refreshDrawer,
    updateCount
  };
})();
